
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {userApi} from "@/api/organization";

    @Component
    export default class TempSave extends Vue {
        @Prop() private form!: any;
        private closePage: any;
        created() {
            this.getTemporaryStorage();
        }
        getTemporaryStorage(){
            userApi.getUserConfig({name: this.$route.name}).then(r => {
                if(r.data.result == 0){
                    const rData = r.data.data;
                    this.$emit("getTempData",rData == null ? "" : rData.config);
                }
            })
        }
        tempSaveBtn(){
            userApi.updateUserConfig({name: this.$route.name, config: JSON.stringify(this.form)}).then(r => {
                if(r.data.result == 0){
                    this.$message.success("暂存成功");
                    this.closePage();
                }
            })
        }
        deleteUserConfig(){
            userApi.deleteUserConfig({name: this.$route.name});
        }
        clearTempData(){
            userApi.deleteUserConfig({name: this.$route.name});
            this.$emit("clearTempData","")
        }
    }
